<script>
import { Doughnut } from "vue-chartjs";

export default {
  extends: Doughnut,
  mounted() {
    // Overwriting base render method with actual data.
    this.renderChart(
      {
        labels: ["January", "February", "March"],
        datasets: [
          {
            labels: "GitHub Commits",
            backgroundColor: ["#f87979", "#668BFB", "#6672FB"],
            data: [40, 20, 12],
            label: {
              // This more specific font property overrides the global property
              fontColor: "black"
            }
          }
        ]
      },
      {
        maintainAspectRatio: false
      }
    );
  }
};
</script>

<style lang="scss" scoped></style>
